export default __webpack_public_path__ + "8d231784dc0435e70ac0f52ab9e0a635.gif";